if (window.location.href === "https://crossjewellia.co.jp/pages/recruit") {
    document.body.classList.add("recruit");

    const accordions = document.querySelectorAll('.accordion');
    if (accordions.length >= 1) {
        const newDivForAccordion = document.createElement('div');
        newDivForAccordion.innerHTML = '求人一覧';
        newDivForAccordion.classList.add('accordion_title');
        accordions[4].parentNode.insertBefore(newDivForAccordion, accordions[0]);
    }
    if (accordions.length >= 7) {
        const newDivForAccordion = document.createElement('div');
        newDivForAccordion.innerHTML = '応募について';
        newDivForAccordion.classList.add('accordion_title');
        accordions[6].parentNode.insertBefore(newDivForAccordion, accordions[6]);
        accordions[6].classList.add('apply');
    }
}